export const FILTERS_INITIALIZE = 'FILTERS_INITIALIZE';
export const FILTERS_UPDATE = 'FILTERS_UPDATE';
export const FILTERS_RESET = 'FILTERS_RESET';
export const FILTER_BY_CHANGE = 'FILTER_BY_CHANGE';
